export default __webpack_public_path__ + "static/media/dubai-trip.da065589.png";